// Diálogo con fondo (radio 18, ficha 02). Escape o clic fuera lo cierran.
import { useEffect, type ReactNode } from 'react';
import { createPortal } from 'react-dom';
import { X } from 'lucide-react';
import { t } from '../i18n/index.ts';

export function Dialog(props: { title: string; onClose: () => void; children: ReactNode; width?: number }) {
  const { onClose } = props;
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => e.key === 'Escape' && onClose();
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [onClose]);
  return createPortal(
    <div className="overlay" onPointerDown={(e) => e.target === e.currentTarget && onClose()}>
      <div className="dialog" role="dialog" aria-label={props.title} style={props.width ? { maxWidth: props.width } : undefined}>
        <div className="dialog-head">
          <span className="ellipsis" title={props.title}>
            {props.title}
          </span>
          <button type="button" className="btn icon" onClick={onClose} title={t('common.close')} aria-label={t('common.close')}>
            <X size={14} />
          </button>
        </div>
        <div className="dialog-body">{props.children}</div>
      </div>
    </div>,
    document.body,
  );
}
